import { globalBigQueryReporter as _globalBigQueryReporter } from '@fiverr-private/identification_core';
import { BigQueryEventName, BigQueryEventsContext } from './bigQuery.types';
import { BIGQUERY_EMBEDDED_PROPERTIES } from './bigQuery.constants';

export const globalBigQueryReporter = _globalBigQueryReporter.extend<BigQueryEventName, BigQueryEventsContext, void>({
    bigQueryEmbeddedProps: BIGQUERY_EMBEDDED_PROPERTIES,
});
